import basket from 'src/assets/images/basket.png'

const Basket = () => {
  return <img id="basket"
    src={basket} />
}

export default Basket
